import { MA_OPPORTUNITIES_SUMMARY_QUERY } from '../operations';
import { useMaOpportunitiesContext } from '../../../MaOpportunitiesContext';
import { useQuery } from '@apollo/client';

export const useGetMaOpportunitiesSummary = () => {
  const { filterVariables } = useMaOpportunitiesContext();
  const { data, loading, error } = useQuery(MA_OPPORTUNITIES_SUMMARY_QUERY, {
    variables: { filters: filterVariables },
  });

  return {
    data: data?.maOpportunitiesSummary || {},
    loading,
    error,
  };
};
